<template>
  <div class="table-overflow-hide">
    <div class="directoryTable scrollable-55vh">
      <table class="table">
        <thead class="sticky-header">
          <tr>
            <th>District ID</th>
            <th>Number of schools</th>
            <th class="icon-col">&nbsp;</th>
            <th>District Name</th>
            <th class="icon-col">&nbsp;</th> 
            <th class="icon-col">
              <v-btn
                @click="schoolStore.districts.reload()"
                icon
                color="gray200"
                size="x-small"
                :loading="schoolStore.districts.loading"
                style="max-width: 20px; max-height: 20px"
              >
                <v-icon>mdi-reload</v-icon></v-btn
              >
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in paginatedResults"
            :key="row.district_id"
            :class="{
              'table-row': true
            }"
          >
            <td data-cy="table-col-name">{{ row.district_id }}</td>
            <td data-cy="table-col-name">{{ row.schools.filter((s) => !s.district && !s.deleted).length }}</td>
            <td>
              <v-btn
                data-cy="directory-impersonate-btn"
                @click="
                  {
                    const districtSchool = row.schools.find((s) => s.district)!;
                    impersonate(
                      districtSchool?.username,
                      row.district_id,
                      districtSchool?.school_id,
                      districtSchool?.subdomain,
                      true
                    );
                  }
                "
                :loading="state.loadImpersonate.includes(row.schools.find((s) => s.district)?.username!)"
                color="gray300"
                density="compact"
                icon
                variant="text"
                :disabled="deleted"
              >
                <v-tooltip activator="parent" location="bottom">Log in as this District</v-tooltip>
                <v-icon color="gray500">mdi-security</v-icon>
              </v-btn>
            </td>
            <td data-cy="table-col-name">{{ row.district_name }}</td>
            <td data-cy="table-col-name">
              <v-btn
                color="gray300"
                density="compact"
                icon
                variant="text"
                @click="
                  restoreModal.show = true;
                  restoreModal.district_id = row.district_id;
                "
              >
                <v-icon color="gray500">mdi-database-refresh</v-icon>
              </v-btn>
            </td>
            <td data-cy="table-col-name">
              <v-btn
                data-cy="edit-district-btn"
                color="gray300"
                density="compact"
                icon
                variant="text"
                @click="
                  editModal.show = true;
                  editModal.district_id = row.district_id;
                "
              >
                <v-icon color="gray500">mdi-note-edit</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="schoolStore.districts.loading && !schoolStore.districts.data.length"
        style="
          height: calc(100% - 60px);
          background-color: rgba(246, 247, 237, 0.5);
          border-radius: 15px;
        "
      >
        <LoadingState text="Loading Schools"></LoadingState>
      </div>
      <div
        v-if="!schoolStore.districts.loading && !schoolStore.districts.data.length"
        style="
          height: calc(100% - 60px);
          background-color: rgba(246, 247, 237, 0.5);
          border-radius: 15px;
        "
      >
        <div class="empty-state">
          <figure style="max-width: 300px">
            <IconListEmptyState />
          </figure>
          <div class="title">We couldn't find any Schools.</div>
          <p>Try reloading the page or adding a new schools.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="table-pagination-btns">
    <pagination
      v-model:curr-page="currPage"
      v-model:per-page="perPage"
      :page-status-text="pageStatusText"
      :total-pages="totalPages"
      @page-down="pageDown"
      @page-up="pageUp"
    ></pagination>
  </div>
  <EditDistrictModal v-model:show="editModal.show" :district_id="editModal.district_id" />
  <v-dialog v-model="restoreModal.show" max-width="500px">
    <v-card>
      <v-card-title>Restore Database</v-card-title>
      <v-card-text>
        <v-form @submit.prevent="restoreDatabase">
          <v-text-field
            v-model="restoreModal.tableName"
            label="Table Name"
            required
          ></v-text-field>
          <v-text-field
            v-model="restoreModal.version"
            label="Version Number"
            type="number"
            min="1"
            max="31"
            :rules="[v => (v >= 1 && v <= 31) || 'Version must be between 1 and 31']"
            required
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="restoreDatabase">Restore</v-btn>
        <v-btn @click="restoreModal.show = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import usePaginate from "@/hooks/usePaginate";
import { computed } from "vue";
import pagination from "@/components/pagination.vue";
import { complexSearch } from "@/utils";

import useSchools from "@/stores/support/schools";
import FetchService from "@/services/fetch.service";
import authService from "@/services/auth.service";
import { useAlertsStore } from "@/stores/alerts";
import LoadingState from "@/components/loadingState.vue";
import IconListEmptyState from "@/assets/icons/list-empty-state.svg";
// @ts-ignore
import EditDistrictModal from "@/components/support/editDistrictModal.vue";
const props = defineProps<{
  search: string;
  deleted: boolean;
}>();
defineEmits<{
  (e: 'update:search', ...args: any[]): void
}>();
const editModal = reactive({ show: false, district_id: 0 });
const restoreModal = reactive({ show: false, district_id: 0, tableName: "", version: 1 });

const state = reactive({
  loadImpersonate: [] as string[],

  loadPinned: [] as string[],
  loadDownload: false
});

const schoolStore = useSchools();
// parentsS.parents.reload();
const filteredData = computed(() => {
  return (
    schoolStore.districts.data?.filter((i) => {
      // console.log(i);
      if (i.deleted !== props.deleted) return false;
      if (
        props.search &&
        !complexSearch(props.search || "", `${i.district_name} ${i.district_name} ${i.district_id}`)
      )
        return false;
      return true;
    }) || []
  );
});

const { currPage, perPage, pageStatusText, totalPages, pageDown, pageUp, paginatedResults } =
  usePaginate(filteredData);

const impersonate = async (username, district_id, school_id, account, is_district: boolean) => {
  state.loadImpersonate.push(username);
  let type = "district";
  if (is_district) {
    type = "district";
  }
  try {
    const res = await FetchService.fetchData(
      `/impersonate?uid=${username}&district_id=${district_id}&school_id=${school_id}&type=${type}`,
      "get"
    );
    if (!res) throw "Failed";
    const data = authService.parseJwt(res, false);
    const tokenName = `ptcwizard_${account}_school_jwt`;
    localStorage.setItem(tokenName, JSON.stringify(data));
    window.open(`/${account}/school`, "_blank");
  } catch (error) {
    useAlertsStore().addAlert("error", "Failed to impersonate school, please try again later");
  }
  state.loadImpersonate = state.loadImpersonate.filter((str) => str !== username);
};

const restoreDatabase = async () => {
  try {
    const res = await FetchService.fetchData(
      `/districts/restore/${restoreModal.district_id}/${restoreModal.version}/${restoreModal.tableName}`,
      "get"
    );
    if (!res) throw "Failed";
    useAlertsStore().addAlert("success", "Database restored successfully");
  } catch (error) {
    useAlertsStore().addAlert("error", "Failed to restore database, please try again later");
  }
  restoreModal.show = false;
};
</script>
<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
.scrollable {
  max-height: 55vh;
  height: 55vh;
  overflow: scroll;
}

.icon-col {
  width: 0px;
}

.table-row {
  td {
    transition: background-color 0.3s;
  }
  &.selected {
    td {
      background-color: #e6e6e689 !important;
    }
  }
}
</style>
